<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Categoría de pago" resource="pago_categorias" primaryKey="idpago_categoria" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" />
    </div>
    <div class="w-full mb-12 px-4" v-if="!isNew">
      <card-list
        title="Subcategorías"
        resource="pago_subcategorias"
        primaryKey="idpago_subcategoria"
        :records="subcategorias"
        :meta="subcategoriasMeta"
        :columns="subcategoriasColumns"
      />
    </div>
  </div>
</template>
<script>
import CardList from "@/components/Cards/CardList.vue";
import CardRecord from "@/components/Cards/CardRecord.vue";
import Pago_categoriaService from "@/services/pago_categoria.service";
import Pago_subcategoriaService from "@/services/pago_subcategoria.service";
import { pago_categoria } from "@/models/pago_categoria";
import { pago_subcategoria } from "@/models/pago_subcategoria";

export default {
  components: {
    CardList,
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: pago_categoria,
      service: Pago_categoriaService,
      subcategorias: {},
      subcategoriasMeta: {},
      subcategoriasColumns: pago_subcategoria.filter(
        (column) => column.showOnList && column.name !== "idpago_categoria"
      ),
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        const params = this.$route.query;
        const subcategoriaFilters = JSON.parse(params.filters || "{}");
        subcategoriaFilters.idpago_categoria = { value: this.idpago_categoria, type: "pago_categoria" };
        params.filters = JSON.stringify(subcategoriaFilters);

        Pago_categoriaService.get(this.idpago_categoria)
          .then((data) => {
            this.record = data.record;
          })
          .catch((response) => {
            console.log(response);
          });

        Pago_subcategoriaService.list(params)
          .then((data) => {
            this.subcategorias = data.records;
            this.subcategoriasMeta = data.meta;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },

  computed: {
    idpago_categoria() {
      return this.$route.params.id;
    },

    isNew() {
      return this.idpago_categoria == "new";
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
